import { INFERENCE_CLOUD_SUPPORT_EMAIL } from "../lib/links.models";

export const MAINTENANCE_MODE_MESSAGE =
  "The system is currently in maintenance mode - check X for updates. Please bear with us.";

export const INSUFFICIENT_ESCROW_EXCLUDED_BALANCE =
  "Insufficient balance for request.";
export const INSUFFICIENT_BALANCE_ADD_CREDITS =
  "Insufficient balance for request. Add credits to continue.";
export const TEAM_INFERENCE_BLOCKED = `This team is not currently allowed to run inference. Please reach out to ${INFERENCE_CLOUD_SUPPORT_EMAIL}.`;
export const TEAM_DISABLED_BILLABLE_WORK = `Team is disabled. Please reach out to ${INFERENCE_CLOUD_SUPPORT_EMAIL}.`;
export const TURNSTILE_TOKEN_VERIFICATION_FAILED =
  "CAPTCHA verification failed.";
export const EMAIL_VERIFICATION_TOKEN_EXPIRED = "Token has expired.";
export const SEND_VERIFICATION_EMAIL_LIMIT_EXCEEDED =
  "Please wait to resend email verification link.";

export function getRateLimitExceededMessage({
  rpm,
  isFreeTier,
}: {
  rpm: number;
  isFreeTier: boolean;
}): string {
  const base = `Rate limit exceeded. Maximum ${rpm} RPM allowed.`;
  return isFreeTier
    ? `${base} Please try again later or purchase credits to increase your limit.`
    : `${base} Please try again later or contact us at ${INFERENCE_CLOUD_SUPPORT_EMAIL} to increase your limit.`;
}
export const getUnsupportedGpuDetectedMessage = ({
  gpuModelName,
  gpuSlugString,
  model,
}: {
  gpuModelName: string;
  gpuSlugString: string;
  model: string | null;
}) =>
  `Unsupported GPU detected${model ? ` for model ${model}` : ""}. Please contact support at ${INFERENCE_CLOUD_SUPPORT_EMAIL} if you believe this is an error. (gpu: ${gpuModelName} - slug: ${gpuSlugString})`;
export const getNoSupportedModelForGpuMessage = (gpuSlug: string) =>
  `No supported model found for GPU. Please contact support at ${INFERENCE_CLOUD_SUPPORT_EMAIL} if you believe this is an error. (gpu: ${gpuSlug})`;
export const NO_GPU_DETECTED = `No GPU detected. Please contact support at ${INFERENCE_CLOUD_SUPPORT_EMAIL} if you believe this is an error.`;

// IMPORTANT: The worker uses this to restart itself, do not change this error message without updating the worker too
export const INSTANCE_RESTART_POSTFIX = "please restart your worker";

export const getUnsupportedEndpointMessage = ({
  method,
  path,
}: {
  method: string;
  path: string;
}) =>
  `${method} on ${path} is currently not supported - please contact us at ${INFERENCE_CLOUD_SUPPORT_EMAIL} if this method is required for your workflow.`;

export const MODEL_OUT_OF_CAPACITY =
  "This model is out of capacity, please try again later";

/** OpenAI's error `type` for a model this platform does not serve, rendered with a 404. */
export const MODEL_NOT_FOUND_ERROR_TYPE = "model_not_found";

/**
 * Error `type` for a prompt that does not fit the model's context window.
 * Shared by the gateway's pre-dispatch size check and the classifier for
 * engine-reported overflows, so both render the same 400 body.
 */
export const CONTEXT_LENGTH_EXCEEDED_ERROR_TYPE = "context_length_exceeded";
